import pick from 'lodash/pick';

import {QuerySingleDashboardType} from 'common/report/controllers/types';
import {Dashboard} from 'common/report/dashboards/types';

import DASHBOARDS_FIXTURE from '../fixtures/dashboard-data.json';
import BOOKMARK_DASHBOARD_IDS_FIXTURE from '../fixtures/bookmark-dashboard-ids-data.json';
import {sleep} from '../util';

let dashboards = (DASHBOARDS_FIXTURE as unknown) as Dashboard[];
const bookmarkDashboardIds = BOOKMARK_DASHBOARD_IDS_FIXTURE;

export class MockDashboardsClient {
  // not everything has a mock-implementation, just the stuff that gets the design-system examples working

  queryAll() {
    return {
      cached: Promise.resolve(null),
      network: (async function () {
        await sleep(1000);
        return dashboards;
      })(),
    };
  }

  querySingle({dashboardID}): QuerySingleDashboardType {
    return {
      cached: Promise.resolve(null),
      network: (async function () {
        await sleep(1000);
        const dashboardInList = dashboards.find((d) => d.id === dashboardID);
        const dashboard = ((dashboardInList
          ? {...dashboardInList, card_order: [], cards: []}
          : null) as unknown) as Dashboard; // eslint-disable-line camelcase
        return dashboard;
      })(),
    };
  }

  async queryBookmarkDashboardIds() {
    await sleep(1000);
    return bookmarkDashboardIds;
  }

  async postCreateDashboard({fields = {}} = {}) {
    await sleep(1000);
    const postData = pick(fields, [`title`, `description`]);
    const newId = Math.max(...dashboards.map((d) => d.id)) + 1;
    const newDashboard = {
      ...postData,
      id: newId,
      card_order: [], // eslint-disable-line camelcase
      cards: [],
    } as Dashboard;
    dashboards = [...dashboards, newDashboard];
    return newDashboard;
  }
}

export const mockDashboardsClient = new MockDashboardsClient();
